import customFieldsReducer from './customFieldsReducer';

export default customFieldsReducer;
